import { ReactElement } from "react"
import { PopIcons, RouteData } from "src/model"
import access from "./localAccess"
import popIcons from "./popup-icons"

const routeData = (path: string, name: string, component: ReactElement<any, any>): RouteData => {
    return { 
        routeProps: {
            path,
            element: component
        },
        name
    }
}

const toTitleCase = (text: string) => {
    text = text.toLowerCase()
    return text[0].toUpperCase() + text.substring(1, text.length)
}

const splitCamelCase = (text: string, isTitleCase?: boolean) => {
    let result = text.replace(/([a-z])([A-Z])/g, '$1 $2')
    result = isTitleCase ? result[0].toUpperCase() + result.substring(1) : result 
    return result
}

const getPageTitle = () => {
    let route = toTitleCase(window.location.href.split('/').pop()!)
    let pageTitle = route ? route.split('-').join(' ') : 'Hydra'
    return pageTitle
}

const retrievApiValidationErrorMsg = (errorObj: any) => {
    const errorProperties = Object.keys(errorObj.fields)
    const message = errorProperties?.[0] ? `${errorProperties[0]} ${errorObj.fields[errorProperties[0]]}` : errorObj?.summary

    return message
}

export const erroMessage = (text: any) => {
    const isOnline = access.getInternetStatus()
    return `Message: ${text || (!isOnline ? 'No Internet Connection' : 'An error occurred')}`
}

export const requestMessage = (resp: any, text = '') => {
    return resp.message || resp.messageString || text || 'Something went wrong'
}

export const catchErrMsg = (err: any) => {
    let message = err?.response?.data?.message || err?.response?.data?.messageString

    if (err.response?.data?.errors && !message) message = retrievApiValidationErrorMsg(err.response.data.errors)
   
    if (err.response?.status === 500) message = "We're experiencing a hiccup on our end, please try again."
    if (err.response?.status === 401) {
        message = 'Session has expired'
        if ( access.getLogoutHandler()) access.getLogoutHandler()()
    }
    return message
}

const moneyFormat = (val: number|string, twoDecimalPlace?: boolean) => {
    var formatter = new Intl.NumberFormat('en-NG', {
        currency: 'NGN',
        minimumFractionDigits: twoDecimalPlace ? 2 : 0,
        maximumFractionDigits: 2
    })
    return formatter.format(Number(val))
}

const getResponderIcon = (type: PopIcons) => {
    const icon = {
        'success': popIcons.SUCCESS,
        'failure': popIcons.FAILURE,
        'password-change': popIcons.PASSWORD_SUCCESS,
        'subsidiary': popIcons.SUBSIDIARY,
        'address-verification': popIcons.ADDRESS_VERIFICATION
    }

    return icon[type] || icon.success
}

export const log = (data: any, description?: string) => {
    if (description) console.log(`====== ${description} =======`)
    console.log(data)
}


export default {
    routeData,
    toTitleCase,
    getPageTitle,
    requestMessage,
    catchErrMsg,
    erroMessage,
    splitCamelCase,
    moneyFormat,
    getResponderIcon,
    log
}